// extracted by mini-css-extract-plugin
export default {"link":"footer_link__pKuKW"};